module.exports = __webpack_public_path__ + "zmenseni-prsou_8_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_8_before.jpg
// module id = 1292
// module chunks = 0